/**
 * 租房管理模块的
 */
import { defineStore } from 'pinia'
const initState = () => ({
  buildingForm: {}, // 新增/编辑楼栋表单
  houseBuildingId: null, // 当前编辑的楼盘id
  contractId: null, // 当前编辑的租房合同id
  houseRoomId: null, // 当前编辑的房间id
  meterRecord: [], // 抄表记录
  furnitureEdit: [], // 批量编辑家具
  curEditExpense: {}, // 当前编辑的费用项（合同级）
  expenseTemplate: {}, // 当前编辑的费用模板（house_expense_item），避免把对象塞进 URL
  roomDetailStatus: [],
  buildingContext: {}, // 列表页透传给楼栋信息页的楼栋摘要（含 floors，详情接口不返回）
})

export const useRentalStore = defineStore(
  'rental',
  () => {
    const rentalData = ref({ ...initState() })
    // 旧版本把合同草稿、身份证/人脸地址与费用项写进了 localStorage。
    // 持久化插件在 setup 之后同步 hydrate，这里在微任务里删除遗留字段并触发一次写入。
    queueMicrotask(() => {
      const legacyKeys = [
        'contractForm',
        'contractAddResult',
        'adjustmentParams',
        'adjustBills',
        'curExpense',
        'roomExpense',
        'selectTime',
        'actionState',
      ]
      const sanitized = { ...rentalData.value } as Record<string, unknown>
      legacyKeys.forEach((key) => delete sanitized[key])
      rentalData.value = sanitized as typeof rentalData.value
    })
    // 获取状态
    const getRentalData = (key) => {
      if (!(key in rentalData.value)) {
        throw new Error(`属性 "${key}" 在 rentalData.value 中不存在`)
      }
      return rentalData.value[key]
    }

    // 设置状态
    const setRentalData = (key, val) => {
      rentalData.value[key] = val
    }
    const resetState = () => {
      rentalData.value = initState()
    }
    return {
      rentalData,
      resetState,
      setRentalData,
      getRentalData,
    }
  },
  {
    persist: true,
  },
)
